function detectPartner() {
  const isUserPartner = import.meta.env.VITE_USER === "partner";
  if (!isUserPartner) return null;
  return location.host?.split(".")?.[0];
}
export { detectPartner };
